import { IconButton } from "@mui/material";
import MuiButton from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputBase from "@mui/material/InputBase";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import React, { useEffect } from "react";
import { LuLayoutGrid } from "react-icons/lu";
import { RiLayoutRowLine, RiRefreshLine } from "react-icons/ri";
import {useNavigate, useLocation} from "react-router-dom";
import advance_click from "../../../images/advance_click.svg";
import advance_non_click from "../../../images/advance_non_click.svg";
import SearchIcon from "../../../images/search.svg";
import AdvanceSearchFilter from "../AdvanceFilter/AdvanceFilter";
import "./SubHeaderComponent.scss";
import { CustomizeColumn } from "../CustomColumn/customize_column";
import WebAppAgentDownload from "../WebAppAgentDownload/WebAppAgentDownload";

const SubHeaderComponent = ({
  search_disabled,
  actions,
  selectedRows,
  placeholder,
  search,
  handleSearch,
  setSearch,
  action,
  filterBy,
  advancefilterBy,
  setAction,
  setFilterBy,
  handleAction,
  filterOptions,
  actionOptions,
  pages_url,
  advanceSearchToggle,
  setAdvanceSearchToggle,
  setAdvancefilterBy,
  showAdvance,
  showTicketAdvanceFilter,
  from,
  setFrom,
  to,
  setTo,
  checkedStateDict,
  setCheckedStateDict,
  rowsPerPage,
  setRowsPerPage,
  all_fields,
  report_type,
  getData,
  setAdvancedQuery,
  addedQuery,
  asset,
  assets,
  setAsset,
  handleAssetWebAppChange,
  download_report,
  selectPage,
  setPageType,
  pageType,
  disable_buttons, ActionComponent, actionComponentProps,
  applyRoleBasedLabels,
  discovery,
  id,
  generalButton,
  showLayoutSwitcher,
  viewLayoutSwitcher,
  setLayoutSwitcher,
  showWebAppAgentDownload,
  onRefresh,
  columnOrder
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleFilterByChange = (event) => {
    setFilterBy(event.target.value);
  };
  const handleActionChange = (event) => {
    setAction(event.target.value);
  };
  const handleViewChange = (viewLayoutSwitcher) => {
    setLayoutSwitcher(viewLayoutSwitcher);
  };
  useEffect(() => {
    if (actionOptions && Array.isArray(actionOptions) && actionOptions.length > 0 && actionOptions[0]?.value) {
      setAction(actionOptions[0].value);
    }
  }, []);

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : '#ced4da'}`,
      color: theme.palette.text.primary,
      fontSize: 16,
      fontWeight: 700,
      lineHeight: "21px",
      fontStyle: "normal",
      padding: "10px 26px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      fontFamily: ['"DM Sans"'].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 0.2rem ${theme.palette.mode === 'dark' ? 'rgba(144, 202, 249, 0.25)' : 'rgba(0,123,255,.25)'}`,
      },
    },
  }));
  const BootstrapInputBorderRadius = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : '#ced4da'}`,
      borderRadius: "4px 0 0 4px",
      color: theme.palette.text.primary,
      fontSize: 16,
      fontWeight: 700,
      lineHeight: "21px",
      fontStyle: "normal",
      padding: "10px 26px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      fontFamily: ['"DM Sans"'].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 0.2rem ${theme.palette.mode === 'dark' ? 'rgba(144, 202, 249, 0.25)' : 'rgba(0,123,255,.25)'}`,
      },
    },
  }));

  const ApplyButton = styled(MuiButton)(({ theme }) => ({
    textTransform: "none",
    fontSize: 14,
    fontWeight: 700,
    padding: "11px 22px",
    border: "0",
    lineHeight: "21px",
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : "#2D3748",
    borderRadius: "0 4px 4px 0",
    color: theme.palette.mode === 'dark' ? theme.palette.text.primary : "#FFFFFF",
    fontFamily: ['"DM Sans"'].join(","),
    "&:hover": {
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : "#2D3748",
      boxShadow: "none",
    }
  }));

  const RefreshButton = styled(MuiButton)({
    textTransform: "none",
    fontSize: 14,
    fontWeight: 700,
    padding: "11px 22px",
    border: "1px solid #5177FF",
    lineHeight: "21px",
    backgroundColor: "transparent",
    borderRadius: "4px",
    color: "#5177FF",
    fontFamily: ['"DM Sans"'].join(","),
    display: "flex",
    alignItems: "center",
    gap: "8px",
    "&:hover": {
      backgroundColor: "rgba(81, 119, 255, 0.1)",
      borderColor: "#5177FF",
      boxShadow: "none",
    },
  });

  const ImageButton = styled(MuiButton)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "8px",
    minWidth: "auto",
    height: "30px",
    textTransform: "none",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : '#ddd'}`,
    borderRadius: "0",
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.action.hover : "#f0f0f0",
    },
    "&.active": {
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.action.selected : "#f0f0f0",
    },
  }));

  const TicketAdvancefilters = [
    { label: "Show Approved", value: "APPROVED" },
    { label: "Show Rejected", value: "DENIED" },
    { label: "Show Pending", value: "PENDING" },
  ];

  return (
    <>
      <div
        className={`d-flex align-items-center w-100 ${
          discovery ? "py-2 mt-0" : " pt-3 rdt_subheader_menu"
        }`}
      >
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: 400,
            backgroundColor: (theme) => theme.palette.background.paper,
            border: (theme) => `1px solid ${theme.palette.primary.main}`,
            color: (theme) => theme.palette.text.primary,
            boxShadow: "none",
          }}
          id="search_field_id"
          className="search_field"
          onSubmit={handleSearch}
        >
          <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
            <img
              src={SearchIcon}
              alt="icon"
              id="center-blueShadow"
              onClick={handleSearch}
            />
          </IconButton>
          <InputBase
            disabled={search_disabled ? true : false}
            sx={{ ml: 1, flex: 1 }}
            placeholder={`Search ${placeholder}`}
            className="search_input"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            inputProps={{ "aria-label": `search for ${placeholder}` }}
          />
        </Paper>

        <div className="d-flex flex-grow-1 justify-content-between align-items-center">
          <FormControl sx={{ m: 1 }} variant="standard">
            <Select
              labelId="demo-customized-select-label"
              id="select_filter_by"
              value={filterBy}
              onChange={handleFilterByChange}
              displayEmpty
              input={<BootstrapInput />}
            >
              <MenuItem value={report_type ? "all" : ""}>
                <em className="select_options">All</em>
              </MenuItem>
              {filterOptions.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  className="select_options"
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className="d-flex flex-grow-1 justify-content-end align-items-center">
            {selectPage && (
              <FormControl sx={{ m: 1 }} variant="standard">
                <Select
                  value={pageType}
                  className="select_options_css"
                  onChange={(event) => setPageType(event.target.value)}
                  input={<BootstrapInput />}
                >
                  {selectPage.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      className="select_options"
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {actionOptions && (
              <div className="d-flex flex-grow-1 justify-content-end align-items-center pe-3">
              <div className="pe-3">
                {ActionComponent ? <ActionComponent {...actionComponentProps}/>: null}
              </div>
                <div className="pe-3">{actions}</div>
                <FormControl variant="standard" sx={{ my: 1 }}>
                  <Select
                    labelId="select-label"
                    id="select_action"
                    className="select_action_class"
                    value={action}
                    onChange={handleActionChange}
                    input={<BootstrapInputBorderRadius />}
                  >
                    {actionOptions.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        className="select_options"
                        disabled={
                          pages_url ===
                            "dashboard/discovery/network_scan_results" ||
                          pages_url ===
                            "dashboard/application-management/assign-policy-to-group/" ||
                          pages_url ===
                            "dashboard/application-management/assign-policy/" ||
                          pages_url ===
                            "dashboard/application-management/application-group/definitions/" ||
                          pages_url ===
                            "dashboard/epm-policy-management/assign-application-groups-to-policy/" ||
                          pages_url ===
                            "dashboard/epm-policy-management/assign-application-definitions-to-policy/" ||
                          pages_url ===
                            "dashboard/endpoint-management/device-assign-policy/" ||
                          pages_url ===
                            "dashboard/endpoint-management/device-group-assign-policy/" ||
                          pages_url ===
                            "dashboard/epm-policy-management/assign-devices-to-policy/" ||
                          pages_url ===
                            "dashboard/epm-policy-management/assign-device-groups-to-policy/" ||
                          pages_url ===
                            "dashboard/epm-policy-management/assign-users-to-policy/" ||
                          pages_url ===
                            "dashboard/endpoint-management/assign-policy-to-user/" ||
                          pages_url ===
                            "dashboard/systemUsers" ||
                          pages_url ===
                            "dashboard/certificates/ca-requested/"
                            ? false
                            : true
                        }
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <ApplyButton
                  className={
                    selectedRows.length > 0
                      ? "apply-button active_button_blue"
                      : "apply-button dactive_button_black"
                  }
                  varient="outlined"
                  size="large"
                  sx={{ my: 1 }}
                  onClick={() => handleAction()}
                  disabled={selectedRows.length === 0}
                >
                  Apply
                </ApplyButton>
              </div>
            )}
            {showTicketAdvanceFilter && (
              <FormControl variant="standard">
                <Select
                  labelId="demo-customized-select-label"
                  id="select_filter_by"
                  value={advancefilterBy}
                  onChange={(event) => setAdvancefilterBy(event.target.value)}
                  displayEmpty
                  input={<BootstrapInput />}
                >
                  <MenuItem value="">
                    <em className="select_options">Show All</em>
                  </MenuItem>
                  {TicketAdvancefilters.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      className="select_options"
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
              {showLayoutSwitcher && (
                <div className="flex_horizontal">
                  <ImageButton
                    className={viewLayoutSwitcher === "columnsView" ? "active" : ""}
                    onClick={() => handleViewChange("columnsView")}
                  >
                    <RiLayoutRowLine size={20} style={{ color: 'inherit' }}/>
                  </ImageButton>
                  <ImageButton
                    className={viewLayoutSwitcher === "cardsView" ? "active" : ""}
                    onClick={() => handleViewChange("cardsView")}
                  >
                    <LuLayoutGrid size={20} style={{ color: 'inherit' }}/>
                  </ImageButton>
                </div>
              )}

            {onRefresh && (
              <div className="d-flex align-items-center" style={{ marginRight: "10px" }}>
                <RefreshButton
                  variant="outlined"
                  size="large"
                  onClick={onRefresh}
                  sx={{ my: 1 }}
                >
                  <RiRefreshLine size={18} />
                  Refresh
                </RefreshButton>
              </div>
            )}
            {location.pathname.includes("my-resources") && showWebAppAgentDownload && <WebAppAgentDownload />}

            {checkedStateDict && (
              <CustomizeColumn
                page_url={pages_url}
                checkedStateDict={checkedStateDict}
                setCheckedStateDict={setCheckedStateDict}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                pageType={report_type}
                columnOrder={columnOrder}
              />
            )}
            {showAdvance && (
              <div className="d-flex algn-items-center">
                <button
                  onClick={() => {
                    setAdvanceSearchToggle((o) => !o);
                  }}
                  className="advance_filter_button"
                  id="image"
                >
                  <img
                    id="advance-svg"
                    src={
                      advanceSearchToggle ? advance_click : advance_non_click
                    }
                    alt="advance_filter"
                  />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className=" w-100 rdt_subheader_menu">
        {advanceSearchToggle && showAdvance && (
          <AdvanceSearchFilter
            page={1}
            rowsPerPage={rowsPerPage}
            from={from}
            setFrom={setFrom}
            to={to}
            setTo={setTo}
            all_fields={all_fields}
            report_type={report_type}
            getData={getData}
            filterBy={filterBy}
            setAdvancedQuery={setAdvancedQuery}
            addedQuery={addedQuery}
            download_report={download_report}
            disable_buttons={disable_buttons}
            applyRoleBasedLabels={applyRoleBasedLabels}
            id={id}
          />
        )}
      </div>
    </>
  );
};

export default SubHeaderComponent;
